import bgBTC from '../assets/images/bg-btc.jpg';
import bgCosts from '../assets/images/bg-costs.jpg';
import bgEstimate from '../assets/images/bg-estimate.jpg';
import bgEuro from '../assets/images/bg-euro.jpg';

import bgBtcAmityAge from '../assets/images/bg-btc-amityAge.png';
import bgCostsAmityAge from '../assets/images/bg-costs-amityAge.png';
import bgEstimateAmityAge from '../assets/images/bg-estimate-amityAge.png';
import bgEuroAmityAge from '../assets/images/bg-euro-amityAge.png';

import bgBtcCryptohall from '../assets/images/bg-btc-cryptohall.png';
import bgCostsCryptohall from '../assets/images/bg-costs-cryptohall.png';
import bgEstimateCryptohall from '../assets/images/bg-estimate-cryptohall.png';
import bgEuroCryptohall from '../assets/images/bg-euro-cryptohall.png';

import bgQurubiqa from '../assets/images/bgQurubiqa.png';

import bgBtcbitCluster from '../assets/images/bg-btc-bitcluster.png';
import bgCostsbitCluster from '../assets/images/bg-costs-bitcluster.png';
import bgEstimatebitCluster from '../assets/images/bg-estimate-bitcluster.png';
import bgEurobitCluster from '../assets/images/bg-euro-bitcluster.png';

import bgBtcPaymine from '../assets/images/bg-btc-paymine.png';
import bgCostsPaymine from '../assets/images/bg-costs-paymine.png';
import bgEstimatePaymine from '../assets/images/bg-estimate-paymine.png';
import bgEuroPaymine from '../assets/images/bg-euro-paymine.png';

import bgBtcDahab from '../assets/images/bg-btc-dahab.png';
import bgCostsDahab from '../assets/images/bg-costs-dahab.png';
import bgEstimateDahab from '../assets/images/bg-estimate-dahab.png';
import bgEuroDahab from '../assets/images/bg-euro-dahab.png';

import bgBtcBMW from '../assets/images/bg-btc-bmw.jpg';
import bgCostsBMW from '../assets/images/bg-costs-bmw.jpg';
import bgEstimateBMW from '../assets/images/bg-estimate-bmw.jpg';
import bgEuroBMW from '../assets/images/bg-euro-bmw.jpg';

import bgBtcStellarForge from '../assets/images/bg-btc-stellar-forge.png';
import bgCostsStellarForge from '../assets/images/bg-costs-stellar-forge.png';
import bgEstimateStellarForge from '../assets/images/bg-estimate-stellar-forge.png';
import bgEuroStellarForge from '../assets/images/bg-euro-stellar-forge.png';

import bgBtcPantheon from '../assets/images/bg-btc-pantheon.png';
import bgCostsPantheon from '../assets/images/bg-costs-pantheon.png';
import bgEstimatePantheon from '../assets/images/bg-estimate-pantheon.png';
import bgEuroPantheon from '../assets/images/bg-euro-pantheon.png';

import bgBtcAvatron from '../assets/images/bg-btc-avatron.png';
import bgCostsAvatron from '../assets/images/bg-costs-avatron.png';
import bgEstimateAvatron from '../assets/images/bg-estimate-avatron.png';
import bgEuroAvatron from '../assets/images/bg-euro-avatron.png';

import bgBtcPolarcore from '../assets/images/bg-btc-polarcore.png';
import bgCostsPolarcore from '../assets/images/bg-costs-polarcore.png';
import bgEstimatePolarcore from '../assets/images/bg-estimate-polarcore.png';
import bgEuroPolarcore from '../assets/images/bg-euro-polarcore.png';

import bgBtcEndlessmining from '../assets/images/bg-btc-endlessmining.png';
import bgCostsEndlessmining from '../assets/images/bg-costs-endlessmining.png';
import bgEstimateEndlessmining from '../assets/images/bg-estimate-endlessmining.png';
import bgEuroEndlessmining from '../assets/images/bg-euro-endlessmining.png';

import bgBtcSabre56 from '../assets/images/bg-btc-sabre56.png';
import bgCostsSabre56 from '../assets/images/bg-costs-sabre56.png';
import bgEstimateSabre56 from '../assets/images/bg-estimate-sabre56.png';
import bgEuroSabre56 from '../assets/images/bg-euro-sabre56.png';

import bgBtcChronosEnergy from '../assets/images/bg-btc-chronos-energy.png';
import bgCostsChronosEnergy from '../assets/images/bg-costs-chronos-energy.png';
import bgEstimateChronosEnergy from '../assets/images/bg-estimate-chronos-energy.png';
import bgEuroChronosEnergy from '../assets/images/bg-euro-chronos-energy.png';

import bgBtcHiggs from '../assets/images/bg-btc-higgs.png';
import bgCostsHiggs from '../assets/images/bg-costs-higgs.png';
import bgEstimateHiggs from '../assets/images/bg-estimate-higgs.png';
import bgEuroHiggs from '../assets/images/bg-euro-higgs.png';

import bgBtcMawson from '../assets/images/bg-btc-mawson.png';
import bgCostsMawson from '../assets/images/bg-costs-mawson.png';
import bgEstimateMawson from '../assets/images/bg-estimate-mawson.png';
import bgEuroMawson from '../assets/images/bg-euro-mawson.png';

import bgBtcRevolveLabs from '../assets/images/bg-btc-revolve-labs.png';
import bgCostsRevolveLabs from '../assets/images/bg-costs-revolve-labs.png';
import bgEstimateRevolveLabs from '../assets/images/bg-estimate-revolve-labs.png';
import bgEuroRevolveLabs from '../assets/images/bg-euro-revolve-labs.png';

import bgBtcHearst from '../assets/images/bg-btc-hearst.png';
import bgCostsHearst from '../assets/images/bg-costs-hearst.png';
import bgEstimateHearst from '../assets/images/bg-estimate-hearst.png';
import bgEuroHearst from '../assets/images/bg-euro-hearst.png';

import bgBtcDatacubes from '../assets/images/bg-btc-datacubes.png';
import bgCostsDatacubes from '../assets/images/bg-costs-datacubes.png';
import bgEstimateDatacubes from '../assets/images/bg-estimate-datacubes.png';
import bgEuroDatacubes from '../assets/images/bg-euro-datacubes.png';

import bgBtcBitasics from '../assets/images/bg-btc-bitasics.png';
import bgCostsBitasics from '../assets/images/bg-costs-bitasics.png';
import bgEstimateBitasics from '../assets/images/bg-estimate-bitasics.png';
import bgEuroBitasics from '../assets/images/bg-euro-bitasics.png';

import bgBtcEmcd from '../assets/images/bg-btc-emcd.png';
import bgCostsEmcd from '../assets/images/bg-costs-emcd.png';
import bgEstimateEmcd from '../assets/images/bg-estimate-emcd.png';
import bgEuroEmcd from '../assets/images/bg-euro-emcd.png';

import bgBtcBlueForge from '../assets/images/bg-btc-blueforge.png';
import bgCostsBlueForge from '../assets/images/bg-costs-blueforge.png';
import bgEstimateBlueForge from '../assets/images/bg-estimate-blueforge.png';
import bgEuroBlueForge from '../assets/images/bg-euro-blueforge.png';

import bgBtcCryptoTech from '../assets/images/bg-btc-cryptotech.png';
import bgCostsCryptoTech from '../assets/images/bg-costs-cryptotech.png';
import bgEstimateCryptoTech from '../assets/images/bg-estimate-cryptotech.png';
import bgEuroCryptoTech from '../assets/images/bg-euro-cryptotech.png';

import bgBtcMiningStore from '../assets/images/bg-btc-miningstore.png';
import bgCostsMiningStore from '../assets/images/bg-costs-miningstore.png';
import bgEstimateMiningStore from '../assets/images/bg-estimate-miningstore.png';
import bgEuroMiningStore from '../assets/images/bg-euro-miningstore.png';

import bgBtcHashlabs from '../assets/images/bg-btc-hashlabs.png';
import bgCostsHashlabs from '../assets/images/bg-costs-hashlabs.png';
import bgEstimateHashlabs from '../assets/images/bg-estimate-hashlabs.png';
import bgEuroHashlabs from '../assets/images/bg-euro-hashlabs.png';

import bgBtcCorPa from '../assets/images/bg-btc-corpa.png';
import bgCostsCorPa from '../assets/images/bg-costs-corpa.png';
import bgEstimateCorPa from '../assets/images/bg-estimate-corpa.png';
import bgEuroCorPa from '../assets/images/bg-euro-corpa.png';

import bgBtcTerahash from '../assets/images/bg-btc-terahash.png';
import bgCostsTerahash from '../assets/images/bg-costs-terahash.png';
import bgEstimateTerahash from '../assets/images/bg-estimate-terahash.png';
import bgEuroTerahash from '../assets/images/bg-euro-terahash.png';

import bgBtcFortris from '../assets/images/bg-btc-fortris.png';
import bgCostsFortris from '../assets/images/bg-costs-fortris.png';
import bgEstimateFortris from '../assets/images/bg-estimate-fortris.png';
import bgEuroFortris from '../assets/images/bg-euro-fortris.png';

import bgBtcYmir from '../assets/images/bg-btc-ymir.png';
import bgCostsYmir from '../assets/images/bg-costs-ymir.png';
import bgEstimateYmir from '../assets/images/bg-estimate-ymir.png';
import bgEuroYmir from '../assets/images/bg-euro-ymir.png';

import bgBtcChazon from '../assets/images/bg-btc-chazon.png';
import bgCostsChazon from '../assets/images/bg-costs-chazon.png';
import bgEstimateChazon from '../assets/images/bg-estimate-chazon.png';
import bgEuroChazon from '../assets/images/bg-euro-chazon.png';

import bgBtcMiningwithbrad from '../assets/images/bg-btc-miningwithbrad.png';
import bgCostsMiningwithbrad from '../assets/images/bg-costs-miningwithbrad.png';
import bgEstimateMiningwithbrad from '../assets/images/bg-estimate-miningwithbrad.png';
import bgEuroMiningwithbrad from '../assets/images/bg-euro-miningwithbrad.png';

import logoAmityAge from '../assets/partnerLogos/amityAge.png';
import logoAvatron from '../assets/partnerLogos/avatron.png';
import logoBitasics from '../assets/partnerLogos/bitasics.avif';
import logoBitcluster from '../assets/partnerLogos/bitcluster.svg';
import logoBlueForge from '../assets/partnerLogos/blueforge.png';
import logoBMW from '../assets/partnerLogos/bmw.png';
import logoChazon from '../assets/partnerLogos/chazon.png';
import logoChronosEnergy from '../assets/partnerLogos/chronos-energy.webp';
import logoCorPa from '../assets/partnerLogos/corpa.png';
import logoCryptoHall24 from '../assets/partnerLogos/cryptohall24.svg';
import logoCryptoTech from '../assets/partnerLogos/cryptotech.png';
import logoDahab from '../assets/partnerLogos/dahab.png';
import logoDatacubes from '../assets/partnerLogos/datacubes.png';
import logoEmcd from '../assets/partnerLogos/emcd.png';
import logoEndlessmining from '../assets/partnerLogos/endlessmining.png';
import logoFortris from '../assets/partnerLogos/fortris.png';
import logoHashlabs from '../assets/partnerLogos/hashlabs.png';
import logoHearst from '../assets/partnerLogos/hearst.png';
import logoHiggs from '../assets/partnerLogos/higgs.png';
import logoMawson from '../assets/partnerLogos/mawson.png';
import logoDuckEnergy from '../assets/partnerLogos/duckEnergy.svg';
import logoMiningStore from '../assets/partnerLogos/miningstore.svg';
import logoMiningWithBrad from '../assets/partnerLogos/miningwithbrad.webp';
import logoPantheon from '../assets/partnerLogos/pantheon.svg';
import logoPaymine from '../assets/partnerLogos/paymine.png';
import logoPolarcore from '../assets/partnerLogos/polarcore.png';
import logoQurubiqa from '../assets/partnerLogos/qurubiqa.png';
import logoRevolveLabs from '../assets/partnerLogos/revolve-labs.png';
import logoSabre56 from '../assets/partnerLogos/sabre56.webp';
import logoStellarForge from '../assets/partnerLogos/stellar-forge.png';
import logoTerahash from '../assets/partnerLogos/terahash.svg';
import logoYmir from '../assets/partnerLogos/ymir.webp';

import amityAgeBackground from '../assets/images/amityAge.png';

export const imageMap = {
  logos: {
    terahash: logoTerahash,
    duckEnergy: logoDuckEnergy,
    'cryptohall24-duerr': logoCryptoHall24,
    'cryptohall24-quetta': logoCryptoHall24,
    amityAge: logoAmityAge,
    qurubiqa: logoQurubiqa,
    bitcluster: logoBitcluster,
    paymine: logoPaymine,
    dahab: logoDahab,
    bmw: logoBMW,
    'stellar-forge': logoStellarForge,
    pantheon: logoPantheon,
    avatron: logoAvatron,
    polarcore: logoPolarcore,
    endlessmining: logoEndlessmining,
    sabre56: logoSabre56,
    'chronos-energy': logoChronosEnergy,
    higgs: logoHiggs,
    mawson: logoMawson,
    'revolve-labs': logoRevolveLabs,
    hearst: logoHearst,
    datacubes: logoDatacubes,
    bitasics: logoBitasics,
    emcd: logoEmcd,
    blueforge: logoBlueForge,
    cryptotech: logoCryptoTech,
    hashlabs: logoHashlabs,
    corpa: logoCorPa,
    miningstore: logoMiningStore,
    fortris: logoFortris,
    ymir: logoYmir,
    chazon: logoChazon,
    miningwithbrad: logoMiningWithBrad,
  },
  backgrounds: {
    terahash: logoTerahash,
    duckEnergy: logoDuckEnergy,
    'cryptohall24-duerr': logoCryptoHall24,
    'cryptohall24-quetta': logoCryptoHall24,
    amityAge: amityAgeBackground,
    qurubiqa: logoQurubiqa,
    bitcluster: logoBitcluster,
    paymine: logoPaymine,
    dahab: logoDahab,
    bmw: logoBMW,
    'stellar-forge': logoStellarForge,
    pantheon: logoPantheon,
    avatron: logoAvatron,
    polarcore: logoPolarcore,
    endlessmining: logoEndlessmining,
    sabre56: logoSabre56,
    'chronos-energy': logoChronosEnergy,
    higgs: logoHiggs,
    mawson: logoMawson,
    'revolve-labs': logoRevolveLabs,
    hearst: logoHearst,
    datacubes: logoDatacubes,
    bitasics: logoBitasics,
    emcd: logoEmcd,
    blueforge: logoBlueForge,
    cryptotech: logoCryptoTech,
    hashlabs: logoHashlabs,
    corpa: logoCorPa,
    miningstore: logoMiningStore,
    fortris: logoFortris,
    ymir: logoYmir,
    miningwithbrad: logoMiningWithBrad,
  },
  images: {
    //default
    euro: bgEuro,
    costs: bgCosts,
    btc: bgBTC,
    estimate: bgEstimate,

    //amityAge
    'bg-btc-amityAge': bgBtcAmityAge,
    'bg-costs-amityAge': bgCostsAmityAge,
    'bg-estimate-amityAge': bgEstimateAmityAge,
    'bg-euro-amityAge': bgEuroAmityAge,

    //cryptohall
    'bg-btc-cryptohall': bgBtcCryptohall,
    'bg-costs-cryptohall': bgCostsCryptohall,
    'bg-estimate-cryptohall': bgEstimateCryptohall,
    'bg-euro-cryptohall': bgEuroCryptohall,

    //qurubiqa
    'bg-btc-qurubiqa': bgQurubiqa,
    'bg-costs-qurubiqa': bgQurubiqa,
    'bg-estimate-qurubiqa': bgQurubiqa,
    'bg-euro-qurubiqa': bgQurubiqa,

    //bitcluster
    'bg-btc-bitcluster': bgBtcbitCluster,
    'bg-costs-bitcluster': bgCostsbitCluster,
    'bg-estimate-bitcluster': bgEstimatebitCluster,
    'bg-euro-bitcluster': bgEurobitCluster,

    //paymine
    'bg-btc-paymine': bgBtcPaymine,
    'bg-costs-paymine': bgCostsPaymine,
    'bg-estimate-paymine': bgEstimatePaymine,
    'bg-euro-paymine': bgEuroPaymine,

    //dahab
    'bg-btc-dahab': bgBtcDahab,
    'bg-costs-dahab': bgCostsDahab,
    'bg-estimate-dahab': bgEstimateDahab,
    'bg-euro-dahab': bgEuroDahab,

    //bmw
    'bg-btc-bmw': bgBtcBMW,
    'bg-costs-bmw': bgCostsBMW,
    'bg-estimate-bmw': bgEstimateBMW,
    'bg-euro-bmw': bgEuroBMW,

    //stellar-forge
    'bg-btc-stellar-forge': bgBtcStellarForge,
    'bg-costs-stellar-forge': bgCostsStellarForge,
    'bg-estimate-stellar-forge': bgEstimateStellarForge,
    'bg-euro-stellar-forge': bgEuroStellarForge,

    //pantheon
    'bg-btc-pantheon': bgBtcPantheon,
    'bg-costs-pantheon': bgCostsPantheon,
    'bg-estimate-pantheon': bgEstimatePantheon,
    'bg-euro-pantheon': bgEuroPantheon,

    //avatron
    'bg-btc-avatron': bgBtcAvatron,
    'bg-costs-avatron': bgCostsAvatron,
    'bg-estimate-avatron': bgEstimateAvatron,
    'bg-euro-avatron': bgEuroAvatron,

    //polarcore
    'bg-btc-polarcore': bgBtcPolarcore,
    'bg-costs-polarcore': bgCostsPolarcore,
    'bg-estimate-polarcore': bgEstimatePolarcore,
    'bg-euro-polarcore': bgEuroPolarcore,

    //endlessmining
    'bg-btc-endlessmining': bgBtcEndlessmining,
    'bg-costs-endlessmining': bgCostsEndlessmining,
    'bg-estimate-endlessmining': bgEstimateEndlessmining,
    'bg-euro-endlessmining': bgEuroEndlessmining,

    //sabre56
    'bg-btc-sabre56': bgBtcSabre56,
    'bg-costs-sabre56': bgCostsSabre56,
    'bg-estimate-sabre56': bgEstimateSabre56,
    'bg-euro-sabre56': bgEuroSabre56,

    //chronos-energy
    'bg-btc-chronos-energy': bgBtcChronosEnergy,
    'bg-costs-chronos-energy': bgCostsChronosEnergy,
    'bg-estimate-chronos-energy': bgEstimateChronosEnergy,
    'bg-euro-chronos-energy': bgEuroChronosEnergy,

    //higgs
    'bg-btc-higgs': bgBtcHiggs,
    'bg-costs-higgs': bgCostsHiggs,
    'bg-estimate-higgs': bgEstimateHiggs,
    'bg-euro-higgs': bgEuroHiggs,

    //mawson
    'bg-btc-mawson': bgBtcMawson,
    'bg-costs-mawson': bgCostsMawson,
    'bg-estimate-mawson': bgEstimateMawson,
    'bg-euro-mawson': bgEuroMawson,

    //revolve-labs
    'bg-btc-revolve-labs': bgBtcRevolveLabs,
    'bg-costs-revolve-labs': bgCostsRevolveLabs,
    'bg-estimate-revolve-labs': bgEstimateRevolveLabs,
    'bg-euro-revolve-labs': bgEuroRevolveLabs,

    //hearst
    'bg-btc-hearst': bgBtcHearst,
    'bg-costs-hearst': bgCostsHearst,
    'bg-estimate-hearst': bgEstimateHearst,
    'bg-euro-hearst': bgEuroHearst,

    //datacubes
    'bg-btc-datacubes': bgBtcDatacubes,
    'bg-costs-datacubes': bgCostsDatacubes,
    'bg-estimate-datacubes': bgEstimateDatacubes,
    'bg-euro-datacubes': bgEuroDatacubes,

    //bitasics
    'bg-btc-bitasics': bgBtcBitasics,
    'bg-costs-bitasics': bgCostsBitasics,
    'bg-estimate-bitasics': bgEstimateBitasics,
    'bg-euro-bitasics': bgEuroBitasics,

    //emcd
    'bg-btc-emcd': bgBtcEmcd,
    'bg-costs-emcd': bgCostsEmcd,
    'bg-estimate-emcd': bgEstimateEmcd,
    'bg-euro-emcd': bgEuroEmcd,

    //blueforge
    'bg-btc-blueforge': bgBtcBlueForge,
    'bg-costs-blueforge': bgCostsBlueForge,
    'bg-estimate-blueforge': bgEstimateBlueForge,
    'bg-euro-blueforge': bgEuroBlueForge,

    //cryptotech
    'bg-btc-cryptotech': bgBtcCryptoTech,
    'bg-costs-cryptotech': bgCostsCryptoTech,
    'bg-estimate-cryptotech': bgEstimateCryptoTech,
    'bg-euro-cryptotech': bgEuroCryptoTech,

    //miningstore
    'bg-btc-miningstore': bgBtcMiningStore,
    'bg-costs-miningstore': bgCostsMiningStore,
    'bg-estimate-miningstore': bgEstimateMiningStore,
    'bg-euro-miningstore': bgEuroMiningStore,

    // hashlabs
    'bg-btc-hashlabs': bgBtcHashlabs,
    'bg-costs-hashlabs': bgCostsHashlabs,
    'bg-estimate-hashlabs': bgEstimateHashlabs,
    'bg-euro-hashlabs': bgEuroHashlabs,

    //corpa
    'bg-btc-corpa': bgBtcCorPa,
    'bg-costs-corpa': bgCostsCorPa,
    'bg-estimate-corpa': bgEstimateCorPa,
    'bg-euro-corpa': bgEuroCorPa,

    //terahash
    'bg-btc-terahash': bgBtcTerahash,
    'bg-costs-terahash': bgCostsTerahash,
    'bg-estimate-terahash': bgEstimateTerahash,
    'bg-euro-terahash': bgEuroTerahash,

    //fortris
    'bg-btc-fortris': bgBtcFortris,
    'bg-costs-fortris': bgCostsFortris,
    'bg-estimate-fortris': bgEstimateFortris,
    'bg-euro-fortris': bgEuroFortris,

    //ymir
    'bg-btc-ymir': bgBtcYmir,
    'bg-costs-ymir': bgCostsYmir,
    'bg-estimate-ymir': bgEstimateYmir,
    'bg-euro-ymir': bgEuroYmir,

    //chazon
    'bg-btc-chazon': bgBtcChazon,
    'bg-costs-chazon': bgCostsChazon,
    'bg-estimate-chazon': bgEstimateChazon,
    'bg-euro-chazon': bgEuroChazon,

    //miningwithbrad
    'bg-btc-miningwithbrad': bgBtcMiningwithbrad,
    'bg-costs-miningwithbrad': bgCostsMiningwithbrad,
    'bg-estimate-miningwithbrad': bgEstimateMiningwithbrad,
    'bg-euro-miningwithbrad': bgEuroMiningwithbrad,
  },
};
